import React from "react";
import { CloseStatus, closeStatusLabels } from "@common/types/closeStatus";
import { BaseFilterProps } from "../../lib";
import { EnumMultiselectFilter } from "../EnumMultiselectFilter/EnumMultiselectFilter";

const closeStatuses = Object.values(CloseStatus);

/** Work page Status filter: Open, Done, Canceled. ANDed with the Stage filter on the server. */
export const CloseStatusFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => (
    <EnumMultiselectFilter
        values={closeStatuses}
        labels={closeStatusLabels}
        value={filters.closeStatuses}
        name="closeStatuses"
        onChange={(selected) => onChange({ closeStatuses: selected })}
    />
);
